import {Component} from '@angular/core';
import {ProductionScheduleItemInPathGroup} from '@domain/production-schedule/production-schedule-item-in-path-group';
import {ProductionScheduleItemInPathGroupStatus} from '@domain/production-schedule/production-schedule-item-in-path-group-status';
import {AssertionUtils} from '@vdw/angular-component-library';
import {ICellRendererAngularComp} from 'ag-grid-angular';
import {ProductionSchedulePartiallyCompletedStatusParams} from './production-schedule-partially-completed-status-cell-renderer-params.interface';

@Component({
  templateUrl: './production-schedule-partially-completed-status-cell-renderer.component.html',
  styleUrls: ['./production-schedule-partially-completed-status-cell-renderer.component.scss']
})
export class ProductionSchedulePartiallyCompletedStatusCellRendererComponent implements ICellRendererAngularComp {
  public productionScheduleItem: ProductionScheduleItemInPathGroup;
  public productionScheduleItemInPathGroupStatus: typeof ProductionScheduleItemInPathGroupStatus = ProductionScheduleItemInPathGroupStatus;

  public agInit(params: ProductionSchedulePartiallyCompletedStatusParams): void {
    this.productionScheduleItem = params?.productionScheduleItem;
  }

  public refresh(params: ProductionSchedulePartiallyCompletedStatusParams): boolean {
    return false;
  }

  public getProductionScheduleItemStatusTranslationKey(status: ProductionScheduleItemInPathGroupStatus): string {
    return AssertionUtils.isNullOrUndefined(status) ? '' : `PRODUCTION_ORDER.PRODUCTION_SCHEDULE_ITEM_IN_PATH_GROUP_STATUS.${ProductionScheduleItemInPathGroupStatus[status]}`;
  }
}
